import React, { Component } from 'react';
import { connect } from 'react-redux';
import OwlCarousel from 'react-owl-carousel2';
import axios from 'axios';
import Layout from '../layout/Layout';
import Callusnow from './Callusnow';

import Loader from 'react-loader-spinner';
import $ from 'jquery'; 


import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Reaptcha from 'reaptcha';


toast.configure(); 

const API_URL = process.env.REACT_APP_API_URL;
const IMAGE_URL = process.env.REACT_APP_SITE_IMAGE_URL;
var fs = require('browserify-fs');
class Contactus extends Component {
	
	constructor(props) {
        super(props);
 
        this.state = {
          
           
			fields: {},
			errors: {},
			languagedata:[],
			defaultlang:6,
			loaded: false,
			verified: false
			
        };
		
		

	    this.handleChange = this.handleChange.bind(this);
		this.submitdonateform = this.submitdonateform.bind(this);

    }

      onVerify = recaptchaResponse => {
    this.setState({
      verified: true
    });
  };


    componentDidMount() {
	  	const DefaultLang = localStorage.getItem('DefaultLanguage');
	    this.setState({defaultlang: DefaultLang});
	
    
  }

	 componentWillMount() {
    	
	  	const DefaultLang = localStorage.getItem('DefaultLanguage');
	   
	this.getlanguage(DefaultLang);
    
  }

getlanguage(defaultlang){
    
   
    axios.post(`${API_URL}/langfile`, { LangId:defaultlang})
        
        .then(res => {
       
          if(res.data.Status == 1)
          {
            const language = res.data.ResponseData;
            let data = res.data.ResponseData[0];
           
             const mythis=this;
             this.setState({ language }); 

              this.setState({languagedata: data});
             
           
                     
            
          }
          })
        
        
        
}
	handleChange(e) {
      let fields = this.state.fields;
      fields[e.target.name] = e.target.value;
      this.setState({
        fields
      });

    }
    submitdonateform(e) {
	
      e.preventDefault();
      if (this.validateForm()) {
          
         
		 axios.post(`${API_URL}/contactus`, {
		 LanguageID:6,		
		 name: this.state.fields.name,
		 email:this.state.fields.email,
		 subject:this.state.fields.subject,
		 message:this.state.fields.message,
		 })
		  .then(res => {

        this.setState({ errorMessage: res.data.Message,status_code:res.data.Status});
		

      toast.success(res.data.Message, {position: toast.POSITION.TOP_RIGHT, autoClose: 2000 });

        if(res.data.Status != 0){
        this.setState({fields : { name:'', email:'', subject:'', message:''} });
      }


       this.setState({
        verified: false
      });

       
	 
		  })
		  
      }else{
      	$('html, body').animate({
		scrollTop:$("#Address_title_scroll").offset().top-100
		}, 1000);
      }




 }
 validateForm() {

      let fields = this.state.fields;
      let errors = {};
      let formIsValid = true;

      if (!fields["name"]) {
        formIsValid = false;
        errors["name"] = "Please enter full name.";
      }

      if (typeof fields["name"] !== "undefined") {
        if (!fields["name"].match(/^[a-zA-Z ]*$/)) {
          formIsValid = false;
          errors["name"] = "Please enter alphabet characters only.";
        }
      }
	  
	  
	  if (!fields["email"]) {
        formIsValid = false;
        errors["email"] = "Please enter email-ID.";
      }

      if (typeof fields["email"] !== "undefined") {
        //regular expression for email validation
        var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
        if (!pattern.test(fields["email"])) {
          formIsValid = false;
          errors["email"] = "Please enter valid email-ID.";
        }
      }
	  
	  
	   if (!fields["subject"]) {
        formIsValid = false;
        errors["subject"] = "Please select subject.";
      }
      if (!fields["message"]) {
        formIsValid = false;
        errors["message"] = "Please enter message.";
      }


       if(this.state.verified==false){
	  	 formIsValid = false;
        errors["captcha"] = "Please Select Reaptcha.";
		}


      this.setState({
        errors: errors
      });
      return formIsValid;


    }


	
	
  render() {
	  

	  
	  
	  
    return (
      <div className="App">
      <Layout languagedata={this.state.languagedata}>
      {this.state.loaded == true ? (    
     
  <div className="divloader"> 
     <Loader 
       type="ThreeDots"
       color="#00BFFF"
       height="100" 
       width="100"
      />      
   </div>
  
  ) : '' }
      
      <section className="banner inner_banner">
		  <div className="bd-example">
		    <div id="carouselExampleCaptions" className="carousel slide" data-ride="carousel">
		      <div className="carousel-inner">
		        <div className="carousel-item active">
		          <img src={ IMAGE_URL+'/images/contact-banner.jpg' } className="d-block w-100" alt={"Swacch Bharat - "+this.state.languagedata.Feel_Free_To_Contact_Us} />
		          <div className="carousel-caption d-none d-md-block">
		            <h1>{this.state.languagedata.Feel_Free_To_Contact_Us}</h1>
		          </div>
		        </div>
		      </div>
		    </div>
		  </div>
		</section>

		<section className="contact_us">
		<div className="container">
		  <div className="row">
		    <div className="col-xl-8 col-lg-8 col-md-8" id="Address_title_scroll">
		      <div className="well well-sm">
		        <form className="form-horizontal has-validation-callback" onSubmit= {this.submitdonateform}>
		          <div className="row">
		            <div className="col-md-6">
		              <div className="form-group">
		                <label for="name">
		                  {this.state.languagedata.Name}</label>
		                <input type="text"
		                 name="name"
		                 id="name" 
		                 autoComplete="off"
		                 className={this.state.errors.name ? "form-control error_class" : "form-control"}
				         placeholder={this.state.errors.name ? this.state.errors.name : ""}  
		                 onChange={this.handleChange} 
		                 value={this.state.fields.name} />
		                
		              </div>
		              <div className="form-group">
		                <label for="email">
		                  {this.state.languagedata.Email_Address}</label>
		                
		                  <input type="email" 
		                  name="email" 
		                  id="email"
		                  autoComplete="off"
		                  className={this.state.errors.email ? "form-control error_class" : "form-control"}
				          placeholder={this.state.errors.email ? this.state.errors.email : ""}   
		                  onChange={this.handleChange} value={this.state.fields.email} />
		                 
		                
		              </div>
		              <div className="form-group">
		                <label for="subject">
		                  {this.state.languagedata.Subject}</label>
		                <select 
		                name="subject" 
		                id="subject"
		        
		                className={this.state.errors.subject ? "form-control error_class" : "form-control"}
				        onChange={this.handleChange} defaultValue={this.state.fields.subject} >
		                  <option value="" >Choose One:</option>
		                  <option value="General">General Customer Service</option>
		                  <option value="Suggestions">Suggestions</option>
		                  <option value="Complaints">Product Support</option>
		                </select>
		                
		              </div>
		            </div>
		            <div className="col-md-6">
		              <div className="form-group">
		                <label for="message">
		                  {this.state.languagedata.Message}</label>
		                <textarea  name="message" 
		                id="message"
		                autoComplete="off"
		                className={this.state.errors.message ? "form-control error_class" : "form-control"}
				        placeholder={this.state.errors.message ? this.state.errors.message : ""} 
		                onChange={this.handleChange} value={this.state.fields.message} ></textarea>
		                
		              </div>
		            </div>

	<div className="col-12 text-left">
		<Reaptcha sitekey="6LdP6-EUAAAAAOUXIJ7-MRV73C_LwXO98dy8cMJX" onVerify={this.onVerify} />
		<div className="text-danger">{this.state.errors.captcha}</div>
    </div>


 

		            <div className="col-md-12">
		              <button type="submit" className="btn btn-primary pull-right" id="btnContactUs">
		                {this.state.languagedata.Send_Message}</button>
		            </div>
		          </div>
		        </form>
		      </div>
		    </div>
		    <div className="col-xl-4 col-lg-4 col-md-4">
		      <form>
		        <h2><span className="fa fa-globe"></span> {this.state.languagedata.Our_office}</h2>
		        <address>
		          <strong>Webmyne Systems Pvt. Ltd.</strong><br />
		          702, Ivory Terrace, Opp. Circuit House<br />
		          R.C. Dutt Road, Vadodara-07<br />
		          Gujarat - India.<br/>
		          <abbr title="Phone">
		            P:</abbr>
		          + 91 (265)233-6907
		        </address>
		        <address>
		          <strong> {this.state.languagedata.contact_us}</strong><br />
		          <p>help[at]webmyne[dot]com</p>
		        </address>
		      </form>
		    </div>
		  </div>
		  <div className="row">
		    <div className="col-12">
		      <div className="map_div">
		        <iframe
		          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1845.5925224022792!2d73.17475275568911!3d22.308840421927247!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xa7b5274fae1b51d5!2sWebmyne+Systems+Pvt.+Ltd.!5e0!3m2!1sen!2sin!4v1432561667772"
		           width="100%" height="100%" frameBorder="0"></iframe>
		      </div>
		    </div>
		  </div>
		</div>
		</section>

		<Callusnow languagedata={this.state.languagedata} />
		</Layout>
	  </div>
    );
  }
}

export default Contactus;



// WEBPACK FOOTER //
// ./src/component/Contactus.js